var map = {
	"./Subtract.svg": "./src/patterns/components/icon/import/svg/Subtract.svg",
	"./apple.svg": "./src/patterns/components/icon/import/svg/apple.svg",
	"./arrow-right.svg": "./src/patterns/components/icon/import/svg/arrow-right.svg",
	"./atm.svg": "./src/patterns/components/icon/import/svg/atm.svg",
	"./calendar-alt.svg": "./src/patterns/components/icon/import/svg/calendar-alt.svg",
	"./calendar.svg": "./src/patterns/components/icon/import/svg/calendar.svg",
	"./cardiology.svg": "./src/patterns/components/icon/import/svg/cardiology.svg",
	"./cart.svg": "./src/patterns/components/icon/import/svg/cart.svg",
	"./chat.svg": "./src/patterns/components/icon/import/svg/chat.svg",
	"./check-fill-alt.svg": "./src/patterns/components/icon/import/svg/check-fill-alt.svg",
	"./check-fill.svg": "./src/patterns/components/icon/import/svg/check-fill.svg",
	"./check-rounded.svg": "./src/patterns/components/icon/import/svg/check-rounded.svg",
	"./check-square.svg": "./src/patterns/components/icon/import/svg/check-square.svg",
	"./check.svg": "./src/patterns/components/icon/import/svg/check.svg",
	"./chevron-bottom-header.svg": "./src/patterns/components/icon/import/svg/chevron-bottom-header.svg",
	"./chevron-bottom.svg": "./src/patterns/components/icon/import/svg/chevron-bottom.svg",
	"./chevron-left.svg": "./src/patterns/components/icon/import/svg/chevron-left.svg",
	"./chevron-right.svg": "./src/patterns/components/icon/import/svg/chevron-right.svg",
	"./chevron-top.svg": "./src/patterns/components/icon/import/svg/chevron-top.svg",
	"./close-btn.svg": "./src/patterns/components/icon/import/svg/close-btn.svg",
	"./close.svg": "./src/patterns/components/icon/import/svg/close.svg",
	"./connect.svg": "./src/patterns/components/icon/import/svg/connect.svg",
	"./credit-card.svg": "./src/patterns/components/icon/import/svg/credit-card.svg",
	"./currency.svg": "./src/patterns/components/icon/import/svg/currency.svg",
	"./diversity.svg": "./src/patterns/components/icon/import/svg/diversity.svg",
	"./download.svg": "./src/patterns/components/icon/import/svg/download.svg",
	"./edit.svg": "./src/patterns/components/icon/import/svg/edit.svg",
	"./email.svg": "./src/patterns/components/icon/import/svg/email.svg",
	"./error-outline.svg": "./src/patterns/components/icon/import/svg/error-outline.svg",
	"./file-upload.svg": "./src/patterns/components/icon/import/svg/file-upload.svg",
	"./first.svg": "./src/patterns/components/icon/import/svg/first.svg",
	"./forum.svg": "./src/patterns/components/icon/import/svg/forum.svg",
	"./google-play.svg": "./src/patterns/components/icon/import/svg/google-play.svg",
	"./help.svg": "./src/patterns/components/icon/import/svg/help.svg",
	"./last.svg": "./src/patterns/components/icon/import/svg/last.svg",
	"./menu.svg": "./src/patterns/components/icon/import/svg/menu.svg",
	"./minus-outline.svg": "./src/patterns/components/icon/import/svg/minus-outline.svg",
	"./minus.svg": "./src/patterns/components/icon/import/svg/minus.svg",
	"./module-handle.svg": "./src/patterns/components/icon/import/svg/module-handle.svg",
	"./page.svg": "./src/patterns/components/icon/import/svg/page.svg",
	"./phone.svg": "./src/patterns/components/icon/import/svg/phone.svg",
	"./pin-atm.svg": "./src/patterns/components/icon/import/svg/pin-atm.svg",
	"./pin-office.svg": "./src/patterns/components/icon/import/svg/pin-office.svg",
	"./pin-temporary.svg": "./src/patterns/components/icon/import/svg/pin-temporary.svg",
	"./pin.svg": "./src/patterns/components/icon/import/svg/pin.svg",
	"./plus-outline.svg": "./src/patterns/components/icon/import/svg/plus-outline.svg",
	"./plus.svg": "./src/patterns/components/icon/import/svg/plus.svg",
	"./quote.svg": "./src/patterns/components/icon/import/svg/quote.svg",
	"./search.svg": "./src/patterns/components/icon/import/svg/search.svg",
	"./shield.svg": "./src/patterns/components/icon/import/svg/shield.svg",
	"./small-pin-atm.svg": "./src/patterns/components/icon/import/svg/small-pin-atm.svg",
	"./small-pin-office.svg": "./src/patterns/components/icon/import/svg/small-pin-office.svg",
	"./small-pin-temporary.svg": "./src/patterns/components/icon/import/svg/small-pin-temporary.svg",
	"./social-facebook.svg": "./src/patterns/components/icon/import/svg/social-facebook.svg",
	"./social-instagram.svg": "./src/patterns/components/icon/import/svg/social-instagram.svg",
	"./social-linkedin.svg": "./src/patterns/components/icon/import/svg/social-linkedin.svg",
	"./union.svg": "./src/patterns/components/icon/import/svg/union.svg",
	"./viber.svg": "./src/patterns/components/icon/import/svg/viber.svg",
	"./whatsapp.svg": "./src/patterns/components/icon/import/svg/whatsapp.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/patterns/components/icon/import/svg sync ^\\.\\/.*\\.svg$";